<dx-validation-group>
  <dx-toolbar class="fields-intervention-toolbar">
    <dxi-item location="before"
              widget="dxButton"
              locateInMenu="never">
      <div *dxTemplate>
        <div class="flex flex-row mr-4 items-center">
          <span class="block mr-2 text-sm font-medium">Date: </span>
          <dx-select-box
            stylingMode="underlined"
            width="140"
            displayExpr="label"
            valueExpr="value"
            placeholder="Filter"
            [value]="request.currentFilter"
            (onValueChanged)="dateFilterChanged($event)"
            [items]="dateFilters">
          </dx-select-box>
        </div>
      </div>
    </dxi-item>
    <dxi-item location="before"
              widget="dxButton"
              locateInMenu="never">
      <div *dxTemplate>
        <div class="flex flex-row mr-4 items-center">
          <span class="block mr-2 text-sm font-medium">Type: </span>
          <dx-select-box
            stylingMode="underlined"
            width="180"
            displayExpr="label"
            valueExpr="value"
            placeholder="Tous"
            [value]="request.interventionType"
            (onValueChanged)="interventionTypeChanged($event)"
            [items]="interventionTypeFilters">
          </dx-select-box>
        </div>
      </div>
    </dxi-item>
    <dxi-item location="before"
              widget="dxButton"
              [visible]="request.currentFilter == 0"
              locateInMenu="never">
      <div *dxTemplate>
        <div class="flex flex-row mr-4 items-center">
          <span class="block mr-2 text-sm font-medium">Début: </span>
          <dx-date-box
            stylingMode="underlined"
            type="datetime"
            [(value)]="request.from">
            <dx-validator>
              <dxi-validation-rule type="required"></dxi-validation-rule>
            </dx-validator>
          </dx-date-box>
        </div>
      </div>
    </dxi-item>
    <dxi-item location="before"
              [visible]="request.currentFilter == 0"
              widget="dxButton"
              locateInMenu="never">
      <div *dxTemplate>
        <div class="flex flex-row mr-4 items-center">
          <span class="block mr-2 text-sm font-medium">Fin: </span>
          <dx-date-box
            stylingMode="underlined"
            type="datetime"
            [(min)]="request.from"
            [(value)]="request.to">
            <dx-validator>
              <dxi-validation-rule type="required"></dxi-validation-rule>
            </dx-validator>
          </dx-date-box>
        </div>
      </div>
    </dxi-item>
    <dxi-item location="before"
              widget="dxButton"
              locateInMenu="auto"
              [options]="generateButtonOptions">
    </dxi-item>
    <dxi-item location="after"
              widget="dxButton"
              locateInMenu="never"
              [visible]="showPendingButton && user.can('list reconstructed_interventions')">
      <div *dxTemplate>
        <dx-button
          text="A valider ({{pendingInterventionsCount > 99 ? '99+' : pendingInterventionsCount}})"
          type="default"
          stylingMode="outlined"
          (onClick)="showPendingInterventions()">
        </dx-button>
      </div>
    </dxi-item>
    <dxi-item location="after"
              widget="dxButton"
              locateInMenu="never">
      <div *dxTemplate>
        <app-fields-interventions-navigation></app-fields-interventions-navigation>
      </div>
    </dxi-item>
  </dx-toolbar>
</dx-validation-group>
<dx-load-panel
  shadingColor="rgba(0,0,0,0.1)"
  [position]="{ of: '.fields-intervention-toolbar' }"
  [visible]="request.isLoading"
  [showIndicator]="true"
  [showPane]="false"
  [shading]="true"
  [closeOnOutsideClick]="false">
</dx-load-panel>
